import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import TableRetailList from "./TableRetailList"
import { useHistory } from "react-router-dom"
import { defaultSearchParams } from "./default-values"
import {
  getRetailListPageDataApi,
  getRetailSalesCSV,
} from "helpers/retail_list_helper"
import Skeleton from "react-loading-skeleton"
import SelectBox from "components/Common/SelectBox"
import { IgarashiCustomerAPI } from "helpers/customer_backend_helper"

import DateInput from "components/Common/DateInput"
import moment from "moment"

const RetailList = () => {
  const [searchParams, setSearchParams] = useState(defaultSearchParams)
  const [data, setData] = useState(null)

  const [totalPages, setTotalPages] = useState(1)
  const [size, setSize] = useState(2)
  const [isFetching, setIsFetching] = useState(false)
  const [customers, setCustomers] = useState([])
  const [customer, setCustomer] = useState({ label: "", value: "" })

  const history = useHistory()

  const loadData = async searchParams => {
    setIsFetching(true)
    try {
      const res = await getRetailListPageDataApi({
        ...searchParams,
        orderDateFrom:
          searchParams.orderDateFrom !== ""
            ? moment(searchParams.orderDateFrom).format("YYYY-MM-DD")
            : "",
        orderDateTo:
          searchParams.orderDateTo !== ""
            ? moment(searchParams.orderDateTo).format("YYYY-MM-DD")
            : "",
      })
      setData(res.data.content)
      setTotalPages(res.data.totalPages)
      // console.log(res.data.number)
      // setActivePage(searchParams.page) // ini menyebabkan auto load berulang2
      // setSize(res.data.size)// ini menyebabkan auto load berulang2
      setIsFetching(false)
    } catch (error) {
      console.log(error)
    }
  }

  const loadCustomers = async () => {
    try {
      const { data } = await IgarashiCustomerAPI.getList()

      if (data.length) {
        const _customers = data.map(item => ({
          value: item.id,
          label: `${item.customerName}`,
          org: item,
        }))
        setCustomers(_customers)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleCustomerSelect = val => {
    const _searchParams = {
      ...searchParams,
      customerName: val?.org?.customerName || "",
    }
    setCustomer(val || "")
    setSearchParams(_searchParams)
  }
  const handleCreate = () => history.push("/retail-list/create")
  const handleEdit = obj => {
    history.push({
      pathname: "/retail-list/edit",
      state: { id: obj.cell.row.original.id },
    })
  }

  const downloadCSV = async () => {
    try {
      const { data } = await getRetailSalesCSV()
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "text/csv;charset=utf-8;" })
      )
      link.setAttribute(
        "download",
        "retail-sales" + new Date().getTime() + ".csv"
      )
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadData(searchParams)
    loadCustomers()
  }, [])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"RTW小売一覧"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col sm="6">
                <Label>受注日</Label>

                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    value={searchParams.orderDateFrom}
                    onChange={date => {
                      setSearchParams({
                        ...searchParams,
                        orderDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setSearchParams({
                        ...searchParams,
                        orderDateFrom: "",
                      })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    value={searchParams.orderDateTo}
                    minDate={searchParams.orderDateFrom}
                    onChange={date =>
                      setSearchParams({
                        ...searchParams,
                        orderDateTo: date[0],
                      })
                    }
                    clear={() =>
                      setSearchParams({
                        ...searchParams,
                        orderDateTo: "",
                      })
                    }
                  />
                </div>
              </Col>
              <Col sm="3">
                <Label>顧客名</Label>
                <Col sm="10">
                  <SelectBox
                    options={customers}
                    value={customer}
                    onChange={handleCustomerSelect}
                  />
                </Col>
              </Col>
              <Col sm="3" className="d-flex align-items-end">
                <Button
                  className="button me-1"
                  onClick={() => loadData(searchParams)}
                >
                  検索
                </Button>
                <Button className="button" onClick={downloadCSV}>
                  CSV出力
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Row>
              <Col className="d-flex justify-content-end">
                <Button className="button  " onClick={handleCreate}>
                  新規受注作成
                </Button>
              </Col>
            </Row>
            <Row className="mb-3 mt-2">
              <Col sm="12">
                {isFetching ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    <TableRetailList
                      page={searchParams.page + 1}
                      count={totalPages}
                      content={data}
                      size={size}
                      onEdit={handleEdit}
                      setSize={size => {
                        let _filter = { ...searchParams }
                        _filter.size = size
                        loadData(_filter)
                        setSize(size)
                      }}
                      setPage={page => {
                        let _filter = { ...searchParams }
                        _filter.page = page
                        setSearchParams(_filter)
                        // loadData(_filter)
                      }}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default RetailList
